import { render, staticRenderFns } from "./EventLogDetailViewIO.vue?vue&type=template&id=0d8ce197&scoped=true&"
import script from "./EventLogDetailViewIO.vue?vue&type=script&lang=js&"
export * from "./EventLogDetailViewIO.vue?vue&type=script&lang=js&"
import style0 from "./EventLogDetailViewIO.vue?vue&type=style&index=0&id=0d8ce197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ce197",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VSpacer,VTextField})
